import { call, put } from 'redux-saga/effects';
import { get, post } from '../../utils/api';
import * as actions from '../actions/fieldsOrder';

export function* getFieldsOrder({ payload }) {
  try {
    const response = {
      ...yield call(get, `/admin/users/settings/${payload.gridName}_${payload.plantType ? `${payload.plantType}_` : ''}${payload.plantId}`),
      gridName: payload.gridName,
      plantType: payload.plantType,
      plantId: payload.plantId
    };
    yield put(actions.getFieldsOrderSuccess(response));
  } catch (error) {
    // yield put(errorModalOpen(error));
    yield put(actions.getFieldsOrderFail(payload));
  }
}

export function* saveFieldsOrder({ payload }) {
  try {
    const response = yield call(
      post,
      `/admin/users/settings/${payload.gridName}_${payload.plantType ? `${payload.plantType}_` : ''}${payload.plantId}`,
      JSON.stringify({ settingsFile: JSON.stringify(payload.reorderFields) })
    );
    yield put(actions.saveFieldsOrderSuccess(response));
  } catch (error) {
    yield put(actions.saveFieldsOrderFail());
  }
}
